// extracted by mini-css-extract-plugin
module.exports = {"externalTrackingImage":"_304fa-AdRNF1QA9VSi2573"};